exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".profile-wrap[data-v-02a7832c] {\n  padding-bottom: 1.5em;\n}\n.profile[data-v-02a7832c] {\n  display: inline-block;\n  padding-left: 0.5em;\n  vertical-align: top;\n}\n", ""]);

// exports
